import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import "./../../Style/SalesDetailStyle.scss";
import { deleteAlert, errorAlert, updateAlert } from "../../Components/Alerts";
import Button from "react-bootstrap/Button";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import jwtDecode from "jwt-decode";
import { AiFillShopping } from "react-icons/ai";
import { Paper, TextareaAutosize } from "@mui/material";
import "jspdf-autotable";
// import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import PrintContent from "../../Print/PrintContent";
import { MdEdit } from "react-icons/md";
// import Select from "react-select";
import InsertSupplier from "../Suppliers/InsertSuppliers";
// import InsertArticle from "../Article/InsertArticle";
import ItemFormModal from "../../NewCRUD/ArticleCRUD/ArticleModal";
import { mainGridHeader, detailsData } from "./FletHyrjeDataGrid";
import DataGridWithActions from "../../Components/DataGridWithActions";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import {
  ElementsParagraph,
  TitleElements,
} from "../../Components/HeadersCRUD-s";
import {
  AddLinkButton,
  LinkAndClickButton,
  AddElementsButton,
} from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import MuiButton from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ButtonGroup from "@mui/material/ButtonGroup";
import OneFieldTotal from "../../Components/OneFieldTotal";
import AccountsAutocompleteEdit from "../../Components/AccountsAutocompleteEdit";
import ArticleAutocompleteInsert from "../../Components/ArticleAutocompleteInsert";
import ArticleAutocompleteEdit from "../../Components/ArticleAutocompleteEdit";

export default function FletHyrje() {
  const TranscationData = [
    {
      id: 1,
      type: "National",
    },
    {
      id: 2,
      type: "International",
    },
  ];

  const [showDetails, setShowDetails] = useState(true);
  const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);
  const headers = authHeader();
  const { fiscalYear } = useContext(FiscalYearContext);

  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDate(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  const [logedEmail, setLogedEmail] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setLogedEmail(decodedToken.email);
    }
  }, []);

  const [data, setData] = useState([]);
  const [detailLine, setDetailLine] = useState([]); //i mban rreshtat e te dhenave detale
  const [formData, setFormData] = useState({
    TransactionID: "",
    InvoiceNr: "",
    Date: "",
    SupplierID: "",
    TransactionType: "",
    Coment: "",
    ModifiedByUser: "",
    AccountID: "",
    ActionType: "",
    // AccountIDSpare:"",
    // Amount0: 0,
    // Amount8: 0,
    // Amount18: 0,
    // VAT8: "",
    // VAT18: "",
    // Total: "",
  });

  const [formDetailData, setFormDetailData] = useState({
    HistoryID: "",
    ArticleID: "",
    QtyInput: "",
    Total: "",
    PriceWithVAT: "",
    PriceWithoutVAT: "",
    ModifiedByUser: "",
    InvoiceNr: "",
  });

  //Per insertimin ne Article History
  const [articleID, setArticleID] = useState("");
  const [qtyinput, setQtyInput] = useState(0);
  const [insertpriceWithoutVAT, setInsertPriceWithoutVAT] = useState(0);
  const [insertPriceWithVAT, setInsertPriceWithVAT] = useState(0);
  const [insertTotal, setInsertTotal] = useState(0);
  const [vatRates, setVATRates] = useState(0);

  const [showEditModal, setShowEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  //   const [supplier, setSupplier] = useState([]);
  const [supplierdetails, setSupplierDetails] = useState([]);

  //   const [articles, setArticles] = useState([]);
  //   const [filteredArticles, setFilteredArticles] = useState([]);

  const [valuedetails, setValueDetails] = useState([]);

  // Te dhenat per printim
  const [headerData, setHeaderData] = useState([]);

  const [companiesData, setCompaniesData] = useState([]);

  const [articlePrintDetails, setArticlePrintDetails] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);

  const [hasElectronicSeal, setHasElectronicSeal] = useState(null);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  // keto konstante sherbejn per ta mbajtur gjendjen e formave nese jane hide ose jo
  const [showEditForm, setShowEditForm] = useState(false);
  const [showInserForm, setShowInsertForm] = useState(true);

  // ky kod i ndryshon gjendjet e formave

  const handleOpenForm2 = () => {
    setShowInsertForm(true);
    setShowEditForm(false); // I fsheh formën e parë
    setArticleID();
    setQtyInput(0);
    setInsertPriceWithoutVAT(0);
    setInsertPriceWithVAT(0);
    setInsertTotal(0);
  };
  const handleOpenForm1 = () => {
    setShowInsertForm(false);
    setShowEditForm(true); // I fsheh formën e parë
  };

  const clearEdit = () => {
    setFormDetailData({
      HistoryID: "",
      ArticleID: "",
      QtyInput: 0,
      PriceWithVAT: 0,
      PriceWithoutVAT: 0,
      Total: 0,
    });
    clearLine();
    handleOpenForm2();
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "EntrySheet", {
        headers,
        params: { fiscalYear: fiscalYear },
      });
      setData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchDetailLineData = async (invoicenr) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "EntrySheet/entrysheetsdetails",
        { headers, params: { invNumber: invoicenr, fiscalYear: fiscalYear } },
      );
      setDetailLine(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //   const fetchArticles = async () => {
  //     try {
  //       const response = await axios.get(ApiLink.API_URL + "Article", {
  //         headers,
  //       });
  //       setArticles(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);

  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message}`);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  const fetchvaluedetails = async (number) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "EntrySheet/getvaluedetails",
        { headers, params: { invNumber: number, fiscalYear: fiscalYear } },
      );
      setValueDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchHeaderData = async (number) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "SalesInDetails/GetPrintHeaderDetails",
        {
          headers,
          params: {
            invNumber: number,
            actionType: "ENS",
            fiscalYear: fiscalYear,
          },
        },
      );
      setHeaderData(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchBanksAccount = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/BankDetails",
        { headers },
      );
      setBankAccounts(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchCompaniesData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers },
      );
      setCompaniesData(response.data);
      setHasElectronicSeal(response.data[0].ElectronicSeal);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticleDataPrint = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetArticleDetailsForPrint",
        {
          headers,
          params: {
            invNumber: formData.InvoiceNr,
            actionType: "ENS",
            fiscalYear: fiscalYear,
          },
        },
      );
      setArticlePrintDetails(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  // Kodi per fshirjen e nje elementi ne databaz
  const handleDelete = async (deleteItemId) => {
    try {
      // const response =
      await axios.delete(ApiLink.API_URL + "EntrySheet" + `/${deleteItemId}`, {
        headers,
      });
      deleteAlert("Fletë hyrja u fshi me sukses");
      fetchData();
    } catch (error) {
      errorAlert("Fletë hyrja nuk mund te fshihet");
    }
  };

  const handleDeleteDetailLine = async (deleteItemIdDetail) => {
    try {
      // const response =
      await axios.delete(
        ApiLink.API_URL + "EntrySheet/oneline" + `/${deleteItemIdDetail}`,
        {
          headers,
          params: {
            email: logedEmail,
            invoiceNR: formData.InvoiceNr,
            fiscalYear: fiscalYear,
          },
        },
      );
      deleteAlert("Linja u fshi me sukses");
      fetchArticleDataPrint();
      fetchData();
      fetchDetailLineData(formData.InvoiceNr);
      fetchvaluedetails(formData.InvoiceNr);
      fetchHeaderData(formData.InvoiceNr);
    } catch (error) {
      deleteAlert("Linja nuk mund te fshihet");
    }
  };

  // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz
  const handleEdit = (item) => {
    fetchSuppliersDetails(item.AccountID);
    fetchDetailLineData(item.InvoiceNr);
    fetchHeaderData(item.InvoiceNr);
    fetchvaluedetails(item.InvoiceNr);
    fetchCompaniesData();
    setFormData({
      TransactionID: item.TransactionID,
      InvoiceNr: item.InvoiceNr,
      Date: item.Date,
      ActionType: item.ActionType,
      // AccountIDSpare: item.AccountIDSpare,
      AccountID: item.AccountID,
      SupplierID: item.SupplierID,
      // Amount0: item.Amount0,
      // Amount8: item.Amount8,
      // Amount18: item.Amount18,
      // VAT8: item.VAT8,
      // VAT18: item.VAT18,
      // Total: item.Total,
      TransactionType: item.TransactionType,
      Coment: item.Coment,
      ModifiedByUser: logedEmail,
    });
    setShowEditModal(true);
    setShowDetails(false);
    handleOpenForm2();
  };

  const handleEditDetails = (item) => {
    handleOpenForm1();
    fetchArticlesSalesPrice(item.ArticleID, "getVat");
    setFormDetailData({
      HistoryID: item.HistoryID,
      ArticleID: item.ArticleID,
      QtyInput: item.QtyInput,
      Total: item.Total,
      PriceWithVAT: item.PriceWithVAT,
      PriceWithoutVAT: item.PriceWithoutVAT,
      ModifiedByUser: logedEmail,
      InvoiceNr: formData.InvoiceNr,
    });
  };

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  //Dergimi i kerkeses per editimin e te dhenave ne backend
  const handleSubmit = (event) => {
    axios
      .put(ApiLink.API_URL + "EntrySheet", formData, { headers })
      .then((response) => {
        // setShowEditModal(false); // Close the edit modal
        fetchData();
        updateAlert("Fletë hyrja u editua me sukses");
        fetchArticleDataPrint();
        fetchHeaderData(formData.InvoiceNr);
      })
      .catch((error) => {
        // alert("Failed to update State");
        errorAlert("Dështoi: Fletë hyrja nuk u editua");
      });
  };

  const handleNewSubmit = (event) => {
    event.preventDefault();
    if (!formData.InvoiceNr) {
      errorAlert("Ju lutem plotësoni numrin e faturës!");
      return;
    }
    const stateDate = {
      InvoiceNr: formData.InvoiceNr,
      Date: formData.Date,
      ArticleID: articleID,
      QtyInput: qtyinput,
      PriceWithoutVAT: insertpriceWithoutVAT,
      PriceWithVAT: insertPriceWithVAT,
      CreatedByUser: logedEmail,
      SupplierID: formData.AccountID,
    };
    axios
      .post(ApiLink.API_URL + "EntrySheet/createnewline", stateDate, {
        headers,
        params: { vatRates: vatRates },
      })
      .then(() => {
        // handleSuccess("Detail  Added Successfully");
        setArticleID("");
        setQtyInput(0);
        setInsertPriceWithoutVAT(0);
        setInsertPriceWithVAT(0);
        setInsertTotal(0);
        fetchData();
        fetchvaluedetails(formData.InvoiceNr);
        fetchHeaderData(formData.InvoiceNr);
        fetchArticleDataPrint();
        setArticlesName();
        fetchDetailLineData(formData.InvoiceNr);
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
        }
      });
  };

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChangeDetail = (event) => {
    const { name, value } = event.target;
    setFormDetailData({ ...formDetailData, [name]: value });
  };
  const handleSubmitDetailLine = (event) => {
    event.preventDefault();
    axios
      .put(
        ApiLink.API_URL + "EntrySheet/updatedetailsArticle",
        formDetailData,
        { headers, params: { vatRates: vatRates, fiscalYear: fiscalYear } },
      )
      .then((response) => {
        fetchDetailLineData(formData.InvoiceNr);
        fetchvaluedetails(formData.InvoiceNr);
        updateAlert("Linja u editua me sukses");
        fetchArticleDataPrint();
        fetchHeaderData(formData.InvoiceNr);
        fetchData();
        handleOpenForm2();
      })
      .catch((error) => {
        errorAlert("Dështoi: Linja nuk u editua");
      });
  };

  const clearLine = () => {
    setQtyInput(0);
    setInsertPriceWithoutVAT(0);
    setInsertPriceWithVAT(0);
    setInsertTotal(0);
    setArticleID();
    fetchDetailLineData(formData.InvoiceNr);
    fetchData();
    fetchvaluedetails(formData.InvoiceNr);
    fetchHeaderData(formData.InvoiceNr);
    fetchArticleDataPrint();
    setArticlesName("");
  };

  // const filteredData = data.filter((item) => {
  //     return (
  //         item.InvoiceNr.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //         item.AccountName.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  // });

  //   const fetchSuppliers = async () => {
  //     try {
  //       const response = await axios.get(
  //         ApiLink.API_URL + "Accounts/accountByLedger",
  //         { headers, params: { ledger: 302 } },
  //       );
  //       setSupplier(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message} `);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  const fetchSuppliersDetails = async (accID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByID",
        { headers, params: { id: accID } },
      );
      setSupplierDetails(response.data);
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const fetchArticlesSalesPrice = async (articleID, form) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/GetSalesPrice",
        { headers, params: { articleID: articleID } },
      );
      const salesPriceData = response.data; // Merr të dy vlerat e "SalesPrice" dhe "VATRates" nga përgjigja

      if (form == "edit") {
        const calculatedValue =
          (parseFloat(response.data.PurchasePrice) * 100) /
          (100 + response.data.PurchasePrice);
        // setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setVATRates(response.data.VATRates);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: response.data.PurchasePrice,
          //   QtyInput: 1,
          PriceWithoutVAT: calculatedValue,
          //   Total: 1 * response.data.PurchasePrice,
          Total: formDetailData.QtyInput * response.data.PurchasePrice,
        }));
      } else if (form == "getVat") {
        // alert("get vat" + vatRates)
      } else {
        setInsertPriceWithVAT(salesPriceData.PurchasePrice);
        setQtyInput(1);
        // Kalkulimi i vlerës pa TVSH dhe vendosja e saj tek PriceWithoutVAT
        const calculatedValue =
          (parseFloat(salesPriceData.PurchasePrice) * 100) /
          (100 + salesPriceData.VATRates);
        setInsertPriceWithoutVAT(calculatedValue.toFixed(2));
        setInsertTotal(1 * salesPriceData.PurchasePrice);
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handleCalculatePriceWithVAT = async (type) => {
    try {
      if (isNaN(insertpriceWithoutVAT)) {
        throw new Error(
          "Çmimi pa TVSH (priceWithoutVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyinput)) {
        throw new Error(
          "Sasia e produkteve (qty input) duhet të jetë një numër.",
        );
      }
      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const vat =
          Number(formDetailData.PriceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT =
          Number(formDetailData.PriceWithoutVAT) + vat;
        const total = Number(formDetailData.QtyInput) * calculatedPriceWithVAT;

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: calculatedPriceWithVAT,
          Total: total,
        }));
      } else {
        const vat = Number(insertpriceWithoutVAT) * (Number(vatRates) / 100);
        const calculatedPriceWithVAT = Number(insertpriceWithoutVAT) + vat;
        const total = Number(qtyinput) * calculatedPriceWithVAT;
        // Veprimet specifike për shtim të ri
        setInsertPriceWithVAT(calculatedPriceWithVAT);
        setInsertTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  const handleCalculatePriceWithoutVAT = async (type) => {
    try {
      if (isNaN(insertPriceWithVAT)) {
        throw new Error(
          "Çmimi me TVSH (priceWithVAT) duhet të jetë një numër.",
        );
      }

      if (isNaN(qtyinput)) {
        throw new Error(
          "Sasia e produkteve (qty input) duhet të jetë një numër.",
        );
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const calculatedPriceWithoutVAT =
          (Number(formDetailData.PriceWithVAT) * 100) /
          (100 + Number(vatRates));
        const total =
          Number(formDetailData.QtyInput) * Number(formDetailData.PriceWithVAT);

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
          Total: total,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const calculatedPriceWithoutVAT =
          (Number(insertPriceWithVAT) * 100) / (100 + Number(vatRates));
        const total = Number(qtyinput) * Number(insertPriceWithVAT);

        setInsertPriceWithoutVAT(calculatedPriceWithoutVAT);
        setInsertTotal(total);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };
  const handleCalculatePrices = async (type) => {
    try {
      if (isNaN(qtyinput)) {
        throw new Error(
          "Sasia e produkteve (qty input) duhet të jetë një numër.",
        );
      }

      if (isNaN(insertTotal)) {
        throw new Error("Totali duhet të jetë një numër.");
      }

      if (type === "edit") {
        // Veprimet specifike për rastin e editimit
        const priceWithVAT =
          Number(formDetailData.Total) / Number(formDetailData.QtyInput);
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));
        // const tempPriceWithVATEdit = Number(priceWithVAT) / (1 - (Number(formDetailData.DiscountPercent) / 100.00));

        setFormDetailData((prevState) => ({
          ...prevState,
          PriceWithVAT: priceWithVAT,
          PriceWithoutVAT: calculatedPriceWithoutVAT,
        }));
      } else {
        // Veprimet specifike për shtim të ri
        const priceWithVAT = Number(insertTotal) / Number(qtyinput);
        const calculatedPriceWithoutVAT =
          (priceWithVAT * 100) / (100 + Number(vatRates));

        setInsertPriceWithoutVAT(calculatedPriceWithoutVAT);
        setInsertPriceWithVAT(priceWithVAT);
      }
    } catch (error) {
      errorAlert("Gabim ne kalkulim: " + error.message);
    }
  };

  //   useEffect(() => {
  //     // Kërko nëse ka diçka të shkruar, në të kundërt shfaq të gjitha llogaritë
  //     setFilteredArticles(
  //       articles.filter((data) =>
  //         data.ArticleName.toLowerCase().includes(searchTerm.toLowerCase()),
  //       ),
  //     );
  //   }, [searchTerm, articles]);

  //   const handleInput = (newValue) => {
  //     const inputValue = newValue.replace(/\W/g, "");
  //     //setDebitLedgerID(inputValue);
  //     setSearchTerm(inputValue);
  //   };

  const [articlesName, setArticlesName] = useState("");
  //   const handleFilterArticles = (selectedOption) => {
  //     if (selectedOption && selectedOption.ArticleID) {
  //       setArticleID(selectedOption.ArticleID);
  //       setArticlesName(selectedOption.label);
  //       fetchArticlesSalesPrice(selectedOption.ArticleID);
  //     } else {
  //       setArticleID("");
  //       setArticlesName("");
  //     }
  //   };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      let nextField;
      switch (e.target.id) {
        case "ArticleID":
          nextField = document.getElementById("QtyInput");
          break;
        case "QtyInput":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithoutVAT":
          nextField = document.getElementById("PriceWithVAT");
          break;
        case "PriceWithVAT":
          nextField = document.getElementById("Total");
          break;
        case "Total":
          if (showEditForm === true && showInserForm === false) {
            handleSubmitDetailLine(e);
          } else if (showInserForm === true && showEditForm === false) {
            handleNewSubmit(e);
          }
          nextField = document.getElementById("ArticleID");
          break;
        default:
          return;
      }
      if (nextField && nextField.select) {
        nextField.focus();
        nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
      }
    }
  };

  const totalAmount = useMemo(() => {
    return data.reduce((sum, item) => sum + Number(item.Total), 0);
  }, [data]);

  const rows = data.map((item, index) => ({
    id: ++index,
    inv: item.InvoiceNr,
    date: item.Date.substring(0, 10),
    client: item.AccountName,
    total: item.Total,
    deleteItemId: item.TransactionID, // Shtimi i një atributi për id e rreshtit për fshirje
    rowInfo: item,
  }));

  const detailsRows = detailLine.map((item, index) => ({
    id: ++index,
    article: item.ArticleName,
    qty: item.QtyInput,
    PNoVAT: item.PriceWithoutVAT,
    PVAT: item.PriceWithVAT,
    amountNoVAT: item.Amount,
    amountVAT: item.Total,
    rowInfo: item,
    deleteItemId: item.HistoryID,
  }));

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    fetchData();
    // fetchSuppliersDetails();
    // fetchDetailLineData();
    // fetchArticles();
    //fetchvaluedetails();
    fetchHeaderData(formData.InvoiceNr);
    fetchCompaniesData();
    fetchArticleDataPrint();
    fetchBanksAccount();
    // fetchSuppliers();
  }, [logedEmail, formData.AccountID, formData.InvoiceNr, fiscalYear]);

  return (
    // <div className="Crud__Container">
    <div className="AccountingSheet__Container" style={{ paddingTop: "50px" }}>
      {showEditModal && (
        <div className="SalesDetail__Container">
          {/* <div className="header_flex">
                        <div className="header_icon">
                            <MdEdit style={{ color: '#466F86', width: "40px" }} />
                            <h3>Edito fletë hyrjen</h3>
                        </div>
                    </div> */}
          <TitleElements icon={MdEdit} title="Edito fletë hyrjen" />
          <hr></hr>
          <div className="SalesDetail__Container__AllButtons">
            <div style={{ display: "flex" }}>
              <div>
                <InsertSupplier type="insert" />
              </div>
              <div style={{ marginLeft: "5px" }}>
                {/* <InsertArticle type="insert" /> */}
                <AddElementsButton
                  text="Krijo Artikull"
                  onClick={() => setIsArticleModalOpen(true)}
                  icon="bi bi-upc-scan"
                  className="button-15"
                />
                <ItemFormModal
                  isOpen={isArticleModalOpen}
                  onClose={() => setIsArticleModalOpen(false)}
                  onSuccess={() => setIsArticleModalOpen(false)}
                  itemToEdit={null}
                />
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "5px" }}>
                {/* <PrintContent details={headerData} companyDetails={companiesData} articleDetails={articlePrintDetails} bankaccounts={bankAccounts} sasia="fletHyrje" actiontype="false" /> */}

                <ButtonGroup
                  variant="contained"
                  ref={anchorRef}
                  // aria-label="Button group with a nested menu"
                >
                  <PrintContent
                    details={headerData}
                    companyDetails={companiesData}
                    articleDetails={articlePrintDetails}
                    bankaccounts={bankAccounts}
                    QTY="QtyInput"
                    sasia="fletHyrje"
                    actiontype="false"
                    hasElectronicSeal={hasElectronicSeal}
                  />

                  <MuiButton
                    style={{
                      width: "30px",
                      height: "35px",
                      marginTop: "10px",
                      borderRadius: "0 5px 5px 0",
                      backgroundColor: "#4E7B67",
                    }}
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    // aria-label="select print option"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon />
                  </MuiButton>
                </ButtonGroup>
                <Popper
                  sx={{ zIndex: 1 }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={hasElectronicSeal} // Lidh me `ElectronicSeal`
                                onChange={(event) =>
                                  setHasElectronicSeal(event.target.checked)
                                } // Përditëson `ElectronicSeal` kur klikohet
                              />
                            }
                            label="Shfaq Vulen Elektronike"
                          />
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>

              <div style={{ marginLeft: "5px" }}>
                <LinkAndClickButton
                  text="Edito"
                  // icon={<FaEnvelope />}
                  link="#"
                  onClick={handleSubmit}
                />
              </div>
              <div style={{ marginLeft: "5px" }}>
                <LinkAndClickButton
                  text="Mbyll"
                  // icon={<FaTrash />}
                  link="/accounting/entrysheet"
                  onClick={() => {
                    setShowDetails(true);
                    setShowEditModal(false);
                  }}
                />
              </div>
            </div>
          </div>
          {/* <div className='header_paper2'></div> */}
          <HeaderPaperComponent />
          <div className="edit">
            <Paper style={{ paddingTop: "20px", paddingBottom: "20px" }}>
              <form className="header_paper">
                <Box
                  // component="form"
                  sx={{
                    "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <div className="SalesDetail__Container__Form">
                    <div className="SalesDetail__Container__Form__div">
                      <div className="SalesDetail__Container__Form__div__1">
                        <div className="SalesDetail__Container__Form__div__2">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__1"
                            id="invoiceNR"
                            label="Invoice Number"
                            variant="outlined"
                            type="text"
                            name="InvoiceNr"
                            value={formData.InvoiceNr}
                            onChange={handleInputChange}
                          />
                          <TextField
                            className="SalesDetail__Container__Form__TextField__1"
                            id="id"
                            select
                            name="TransactionType"
                            label="Select Transaction Type"
                            value={formData.TransactionType}
                            onChange={handleInputChange}
                          >
                            {TranscationData.map((data) => (
                              <MenuItem key={data.id} value={data.id}>
                                {data.type}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextareaAutosize
                            style={{ height: "70px", marginLeft: "10px" }}
                            className="SalesDetail__Container__Form__TextField__1"
                            id="Coment"
                            label="Coment"
                            type="text"
                            name="Coment"
                            value={formData.Coment}
                            onChange={handleInputChange}
                            variant="outlined"
                          />
                        </div>
                        <div className="SalesDetail__Container__Form__TextField__date__Payment">
                          <TextField
                            className="SalesDetail__Container__Form__TextField__date"
                            id="date"
                            type="date"
                            variant="outlined"
                            label="Invoice Date"
                            name="Date"
                            value={formData.Date.substring(0, 10)}
                            onChange={handleInputChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              min: minDate, // Kufizimi minimal i datës
                              max: maxDate, // Kufizimi maksimal i datës
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="SalesDetail__Container__Form__div__4">
                      <div>
                        {/* <TextField className="SalesDetail__Container__Form__TextField__2"
                                                    // style={{ width: "96%" }}
                                                    id="AccountID"
                                                    name="AccountID"
                                                    select
                                                    label="Select Supplier"
                                                    value={formData.AccountID}
                                                    onChange={handleInputChange}
                                                >
                                                    {supplier.map((data) => (
                                                        <MenuItem key={data.AccountID} value={data.AccountID}>{data.AccountName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField> */}

                        <AccountsAutocompleteEdit
                          ledgerID={302}
                          // reloadKey={1}
                          accountID={formData.AccountID}
                          labelId="AccountID"
                          label="Furnitori"
                          onSelect={(account) => {
                            // setShowInventoryAlert(true);
                            // fetchArticleInventory(article.ArticleID);
                            setFormData((prev) => ({
                              ...prev,
                              AccountID: account.AccountID,
                            }));
                          }}
                          onClear={() =>
                            setFormData((prev) => ({
                              ...prev,
                              AccountID: "",
                            }))
                          }
                        />
                      </div>
                      <div style={{ display: "flex" }}>
                        <TextField
                          className="SalesDetail__Container__Form__TextField__IDNumber"
                          // style={{ width: "49%" }}
                          id="outlined-basic"
                          label="Identification Number"
                          variant="outlined"
                          name="IdentificationNumber"
                          value={
                            supplierdetails.length > 0
                              ? supplierdetails[0].IdentificationNumber
                              : ""
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          readOnly
                          autoComplete="off"
                        />
                        <TextField
                          className="SalesDetail__Container__Form__TextField__IDNumber"
                          // style={{ width: "49%" }}
                          id="outlined-basic"
                          label="VAT Number"
                          variant="outlined"
                          name="VatNumber"
                          value={
                            supplierdetails.length > 0
                              ? supplierdetails[0].VATNumber
                              : ""
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          readOnly
                          autoComplete="off"
                        />
                      </div>
                      <div>
                        <TextField
                          className="SalesDetail__Container__Form__TextField__2"
                          // style={{ width: "96%" }}
                          id="outlined-basic"
                          label="Address"
                          variant="outlined"
                          name="Address"
                          value={
                            supplierdetails.length > 0
                              ? supplierdetails[0].Adress
                              : ""
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          readOnly
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </Box>
              </form>
              <div style={{ backgroundColor: "gainsboro" }}>
                <hr></hr>
                {showInserForm && (
                  <div className="SalesDetail__Container">
                    <form
                      onSubmit={handleNewSubmit}
                      className="header_paper"
                      onKeyPress={handleKeyPress}
                    >
                      <Box
                        // component="form"
                        sx={{
                          "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        {/* <p style={{ color: "blue", fontSize: "16px", fontWeight: "bold", borderTop: "1px dashed blue" }}>Please fill in all the required fields.</p> */}
                        <div className="SalesDetail__Container__Second__Form">
                          <div
                            className="SalesDetail__Container__Second__Form__Article"
                            style={{ paddingTop: "12px" }}
                          >
                            {/* <span
                              style={{
                                marginBottom: "-10px",
                                color: "black",
                                marginLeft: "10px",
                                fontSize: "13px",
                              }}
                            >
                              Select Article
                            </span> */}
                            {/* <Select
                              className="SalesDetail__Container__Form__TextField__Article__SelectList"
                              inputId="ArticleID"
                              value={{ label: articlesName, value: articleID }}
                              options={filteredArticles.map((data) => ({
                                label: data.ArticleName,
                                value: data.ArticleID,
                                ArticleID: data.ArticleID,
                              }))}
                              onInputChange={handleInput}
                              onChange={handleFilterArticles}
                              isClearable
                              placeholder="Select"
                              noOptionsMessage={() => "No matching"}
                              components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  height: "55px",
                                  marginLeft: "10px",
                                  marginRight: "12px",
                                  backgroundColor: "transparent",
                                  border: "darkgray solid 1px",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  backgroundColor: "#fff",
                                  zIndex: 9999,
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  borderRadius: "4px",
                                }),
                                menuList: (provided) => ({
                                  ...provided,
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: "#000",
                                }),
                              }}
                            /> */}

                            <ArticleAutocompleteInsert
                              value={articlesName}
                              label="Kerko Artikullin"
                              priceType="purchase"
                              onSelect={(article) => {
                                setArticleID(article.ArticleID);
                                fetchArticlesSalesPrice(article.ArticleID);
                                setArticlesName(article);
                              }}
                              onClear={() => {
                                setArticleID("");
                                setArticlesName(null);
                              }}
                              labelId="ArticleID"
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Form__TextField__Output"
                                id="QtyInput"
                                type="text"
                                variant="outlined"
                                label="QTY Input"
                                name="QtyInput"
                                value={qtyinput}
                                onChange={(e) => setQtyInput(e.target.value)}
                                onKeyUp={handleCalculatePriceWithoutVAT}
                              />
                            </div>
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Second__Form__Price"
                                id="PriceWithoutVAT"
                                type="text"
                                variant="outlined"
                                label="Price Without VAT"
                                name="PriceWithoutVAT"
                                value={
                                  typeof insertpriceWithoutVAT === "number"
                                    ? insertpriceWithoutVAT.toFixed(4)
                                    : insertpriceWithoutVAT
                                }
                                onChange={(e) =>
                                  setInsertPriceWithoutVAT(e.target.value)
                                }
                                onKeyUp={handleCalculatePriceWithVAT}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Second__Form__Price"
                                id="PriceWithVAT"
                                type="text"
                                variant="outlined"
                                label="Price With VAT"
                                name="PriceWithVAT"
                                autoComplete="off"
                                value={
                                  typeof insertPriceWithVAT === "number"
                                    ? insertPriceWithVAT.toFixed(4)
                                    : insertPriceWithVAT
                                }
                                onChange={(e) =>
                                  setInsertPriceWithVAT(e.target.value)
                                }
                                onKeyUp={handleCalculatePriceWithoutVAT}
                              />
                            </div>
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Second__Form__Price"
                                id="Total"
                                label="Total"
                                variant="outlined"
                                name="Total"
                                value={
                                  typeof insertTotal === "number"
                                    ? insertTotal.toFixed(2)
                                    : insertTotal
                                }
                                onChange={(event) =>
                                  setInsertTotal(event.target.value)
                                }
                                onKeyUp={handleCalculatePrices}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                            <div className="butonat">
                              <div>
                                <Button
                                  type="submit"
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-plus-lg"></i>
                                </Button>
                              </div>
                              <div>
                                <Button
                                  variant="danger"
                                  onClick={clearLine}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-x-lg"></i>
                                </Button>
                              </div>
                            </div>

                            <div className="responsive">
                              <div className="responsive__butonat">
                                <div>
                                  <Button
                                    type="submit"
                                    variant="success"
                                    style={{
                                      borderRadius: "0",
                                      width: "45px",
                                      height: "45px",
                                    }}
                                  >
                                    <i class="bi bi-plus-lg"></i>
                                  </Button>
                                </div>
                                <div>
                                  <Button
                                    variant="danger"
                                    onClick={clearLine}
                                    style={{
                                      borderRadius: "0",
                                      width: "45px",
                                      height: "45px",
                                    }}
                                  >
                                    <i class="bi bi-x-lg"></i>
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Box>
                    </form>
                  </div>
                )}
                {showEditForm && (
                  <div className="SalesDetail__Container">
                    <form
                      onSubmit={handleSubmitDetailLine}
                      className="header_paper"
                      onKeyPress={handleKeyPress}
                    >
                      <Box
                        // component="form"
                        sx={{
                          "& .MuiTextField-root": { m: 1.3, width: "41ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <div className="SalesDetail__Container__Second__Form">
                          <div
                            className="SalesDetail__Container__Second__Form__Article"
                            style={{ paddingTop: "12px" }}
                          >
                            {/* <TextField
                              className="SalesDetail__Container__Form__TextField__Article"
                              id="ArticleID"
                              select
                              label="Select Article"
                              name="ArticleID"
                              value={formDetailData.ArticleID}
                              autoComplete="off"
                              // onChange={handleInputChangeDetail}
                              onChange={(event) => {
                                handleInputChangeDetail(event); // Ndryshimi i selectedArticleID në ngjarjen onChange
                                fetchArticlesSalesPrice(
                                  event.target.value,
                                  "edit",
                                ); // Thirja e funksionit këtu
                              }}
                              // onKeyUp={handleCalculatePriceWithoutVATEdit}
                            >
                              {articles.map((data) => (
                                <MenuItem
                                  key={data.ArticleID}
                                  value={data.ArticleID}
                                >
                                  {data.ArticleName}
                                </MenuItem>
                              ))}
                            </TextField> */}

                            <ArticleAutocompleteEdit
                              articleId={formDetailData.ArticleID}
                              labelId="ArticleID"
                              priceType="purchase"
                              onSelect={(article) => {
                                setFormDetailData((prev) => ({
                                  ...prev,
                                  ArticleID: article.ArticleID,
                                }));

                                fetchArticlesSalesPrice(
                                  article.ArticleID,
                                  "edit",
                                );
                              }}
                              onClear={() =>
                                setFormDetailData((prev) => ({
                                  ...prev,
                                  ArticleID: "",
                                }))
                              }
                            />
                          </div>
                          <div className="SalesDetail__Container__Second__Form__details__OtherInputs">
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Form__TextField__Output"
                                type="text"
                                id="QtyInput"
                                name="QtyInput"
                                label="Qty Input"
                                variant="outlined"
                                autoComplete="off"
                                value={formDetailData.QtyInput}
                                onChange={handleInputChangeDetail}
                                onKeyUp={() =>
                                  handleCalculatePriceWithoutVAT("edit")
                                }
                              />
                            </div>
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Form__TextField__Output"
                                id="PriceWithoutVAT"
                                type="text"
                                variant="outlined"
                                label="Price Without VAT"
                                name="PriceWithoutVAT"
                                autoComplete="off"
                                value={
                                  typeof formDetailData.PriceWithoutVAT ===
                                  "number"
                                    ? formDetailData.PriceWithoutVAT.toFixed(4)
                                    : formDetailData.PriceWithoutVAT
                                }
                                onChange={handleInputChangeDetail}
                                onKeyUp={() =>
                                  handleCalculatePriceWithVAT("edit")
                                }
                              />
                            </div>
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Form__TextField__Output"
                                id="PriceWithVAT"
                                type="text"
                                variant="outlined"
                                label="Price With VAT"
                                name="PriceWithVAT"
                                autoComplete="off"
                                value={
                                  typeof formDetailData.PriceWithVAT ===
                                  "number"
                                    ? formDetailData.PriceWithVAT.toFixed(4)
                                    : formDetailData.PriceWithVAT
                                }
                                onChange={handleInputChangeDetail}
                                onKeyUp={() =>
                                  handleCalculatePriceWithoutVAT("edit")
                                }
                              />
                            </div>
                            <div className="SalesDetail__Container__Second__Form__details">
                              <TextField
                                className="SalesDetail__Container__Form__TextField__Output"
                                id="Total"
                                label="Total"
                                variant="outlined"
                                name="Total"
                                autoComplete="off"
                                value={
                                  typeof formDetailData.Total === "number"
                                    ? formDetailData.Total.toFixed(2)
                                    : formDetailData.Total
                                }
                                onChange={handleInputChangeDetail}
                                onKeyUp={() => handleCalculatePrices("edit")}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                            <div className="butonat">
                              <div>
                                <Button
                                  type="submit"
                                  variant="success"
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-check-lg"></i>
                                </Button>
                              </div>
                              <div>
                                <Button
                                  variant="danger"
                                  onClick={clearEdit}
                                  style={{
                                    borderRadius: "0",
                                    width: "45px",
                                    height: "45px",
                                  }}
                                >
                                  <i class="bi bi-x-lg"></i>
                                </Button>
                              </div>
                            </div>

                            <div className="responsive">
                              <div className="responsive__butonat">
                                <div>
                                  <Button
                                    type="submit"
                                    variant="success"
                                    style={{
                                      borderRadius: "0",
                                      width: "45px",
                                      height: "45px",
                                    }}
                                  >
                                    <i class="bi bi-check-lg"></i>
                                  </Button>
                                </div>
                                <div>
                                  <Button
                                    variant="danger"
                                    onClick={clearEdit}
                                    style={{
                                      borderRadius: "0",
                                      width: "45px",
                                      height: "45px",
                                    }}
                                  >
                                    <i class="bi bi-x-lg"></i>
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Box>
                    </form>
                  </div>
                )}
                <DataGridWithActions
                  columns={detailsData}
                  rows={detailsRows}
                  handleEdit={handleEditDetails}
                  handleDelete={handleDeleteDetailLine}
                  showPayment={false}
                />
              </div>
              <br></br>
              <div className="responsive__Tablet">
                <div className="SalesDetail__Container__Form">
                  <div style={{ marginLeft: "20px" }}>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__Amount18"
                      // style={{ width: "100%" }}
                      id="Amount18"
                      label="Amount 18"
                      variant="outlined"
                      type="text"
                      name="Amount18"
                      value={
                        valuedetails.length > 0
                          ? valuedetails[0].Amount18.toFixed(2)
                          : ""
                      }
                      disabled
                    />
                    <br></br>
                    <br></br>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__VAT18"
                      // style={{ width: "100%" }}
                      id="VAT18"
                      label="VAT 18"
                      variant="outlined"
                      type="text"
                      name="VAT18"
                      value={
                        valuedetails.length > 0
                          ? valuedetails[0].VAT18.toFixed(2)
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <br></br>
                  <div style={{ marginLeft: "20px" }}>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__Amount8"
                      // style={{ width: "100%" }}
                      id="Amount8"
                      label="Amount 8"
                      variant="outlined"
                      type="text"
                      name="Amount8"
                      value={
                        valuedetails.length > 0
                          ? valuedetails[0].Amount8.toFixed(2)
                          : ""
                      }
                      disabled
                    />
                    <br></br>
                    <br></br>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__VAT8"
                      // style={{ width: "100%" }}
                      id="VAT8"
                      label="VAT 8"
                      variant="outlined"
                      type="text"
                      name="VAT8"
                      value={
                        valuedetails.length > 0
                          ? valuedetails[0].VAT8.toFixed(2)
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <br></br>
                  <div style={{ marginLeft: "20px" }}>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__Amount0"
                      // style={{ width: "100%" }}
                      id="Amount0"
                      label="Amount 0"
                      variant="outlined"
                      type="text"
                      name="Amount0"
                      value={
                        valuedetails.length > 0
                          ? valuedetails[0].Amount0.toFixed()
                          : ""
                      }
                      disabled
                    />
                    <br></br>
                    <br></br>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__VAT0"
                      // style={{ width: "100%" }}
                      id="VAT0"
                      label="VAT 0"
                      variant="outlined"
                      type="text"
                      name="VAT0"
                      value={valuedetails.length > 0 ? 0 : ""}
                      disabled
                    />
                  </div>
                  <br></br>
                  {/* <div>
                                        <TextField
                                            style={{ width: "81%" }}
                                            id="DiscountAmount"
                                            label="Zbritja në vlerë"
                                            variant="outlined"
                                            type="text"
                                            name="DiscountAmount"
                                            value={discountAmount}
                                            onChange={(e) => { setDiscountAmount(e.target.value); calculatePercent(e.target.value); }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Tooltip title="Apliko Zbritjen" placement="right">
                                                            <IconButton type="submit"
                                                                onClick={constUpdateDiscountAmount}
                                                            >
                                                                <i class="bi bi-check-lg" style={{ color: "green" }}></i>

                                                            </IconButton>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <br></br>
                                        <br></br>
                                        <TextField
                                            className="SalesDetail__Container__Form__TextField__TotalAmount"
                                            id="TotalAmount"
                                            label="Total pa TVSH"
                                            variant="outlined"
                                            type="text"
                                            name='TotalAmount'
                                            value={valuedetails.length > 0 ? (valuedetails[0].Amount18 + valuedetails[0].Amount8 + valuedetails[0].Amount0).toFixed(2) : ''}
                                            readOnly
                                        />
                                    </div> */}

                  <br></br>
                  <div>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__VATTotal"
                      // style={{ width: "100%" }}
                      id="VATTotal"
                      label="Total TVSH"
                      variant="outlined"
                      type="text"
                      name="VATTotal"
                      value={
                        valuedetails.length > 0
                          ? (
                              valuedetails[0].Total -
                              (valuedetails[0].Amount18 +
                                valuedetails[0].Amount8 +
                                valuedetails[0].Amount0)
                            ).toFixed(2)
                          : ""
                      }
                      readOnly
                    />
                    <br></br>
                    <br></br>
                    <TextField
                      className="SalesDetail__Container__Form__TextField__Total"
                      // style={{ width: "100%" }}
                      id="Totali"
                      label="Për pagesë"
                      variant="outlined"
                      type="text"
                      name="Totali"
                      value={
                        valuedetails.length > 0
                          ? valuedetails[0].Total.toFixed(2)
                          : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      )}
      {showDetails && (
        <div className="shfaqePermbajtjen">
          <div className="header_flex">
            <TitleElements icon={AiFillShopping} title="Fletë hyrje" />

            <AddLinkButton
              text="Krijo fletë hyrje"
              icon="bi bi-plus-circle"
              link="/accounting/insertentrysheet"
            />
          </div>
          <ElementsParagraph text="Forma e fletë hyrjeve: Menaxhoni, shtoni, editoni dhe fshini fletë hyrjen." />

          <DataGridWithActions
            columns={mainGridHeader}
            rows={rows}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            showPayment={false}
            height={500}
          />

          <OneFieldTotal id={1} label="Vlera" value={totalAmount} />
        </div>
      )}
    </div>
  );
}
